export const COMPONENT_DTO_TYPES = {
  TEXT: 'text',
  IMAGE: 'image',
  LINK: 'link',
  VIDEO: 'video',
  SINGLE_CHOICE_QUESTION: 'single_choice_question',
  TEXT_QUESTION: 'text_question',
  MEETING: 'meeting',
};

export const OPERATE_TYPES = {
  TEST: 'test',
  REPLACE: 'replace',
  ADD: 'add',
  REMOVE: 'remove',
  MOVE: 'move',
  COPY: 'copy',
};

export const ROLE = {
  admin: 'admin',
  manager: 'manager',
  teacher: 'teacher',
  student: 'student',
};
